import React from "react";


class Loader extends React.Component {
    render() {
        return (
            <div className="cont-spinner">
                <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        )
    }
}
export default Loader;